import { anyInvalid as origAnyInvalid } from 'eflex/util/getter-helpers';

export default function anyInvalid(data) {
  return origAnyInvalid(data);
}
